import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { INVITER_PARAM_KEY } from '@/config/constants/query';

interface AppealTextProps {
  defaultText: string;
}

const AppealText: FC<AppealTextProps> = ({ defaultText }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inviter = queryParams.get(INVITER_PARAM_KEY);

  if (!inviter) {
    return <>{defaultText}</>;
  }
  return <>\ ↓から登録で友だち招待特典ゲット /</>;
};

export default AppealText;
